<template>
	<div class="container ar">
		<!-- loader -->
		<loader v-if="loading" height="60vh" class="mb-5" />

		<!-- news content -->
		<div v-else class="news-content">
			<vue-easy-lightbox
				class="mx-0"
				escDisabled
				moveDisabled
				:visible="visible"
				:imgs="news.images"
				:index="index"
				@hide="handleHide">
				<template v-slot:prev-btn="{ prev }">
					<!-- <button @click="prev">show the prev</button> -->
					<div class="prev" @click="prev"></div>
				</template>

				<template v-slot:next-btn="{ next }">
					<!-- <button @click="next">show the next</button> -->
					<div class="next" @click="next"></div>
				</template>
			</vue-easy-lightbox>

			<breadcrumbs
				class="breadcrumbs ar"
				:links="[
					{ name: $t('links.home'), link: { name: 'home' } },
					{ name: $t('links.home'), link: { name: 'all-news' } },
					{ name: news.title, link: {}, active: true },
				]"></breadcrumbs>

			<div class="top">
				<div class="title">{{ news.title }}</div>
				<div class="date">{{ moment(news.updated_at) }}</div>
			</div>
			<div class="main">
				<div class="para ck-content" v-html="news.content"></div>
				<div class="imgs">
					<div class="big-img">
						<img :src="news.images[0]" alt @click="showMultiple(0)" />
					</div>
					<div class="related-imgs" ref="related">
						<div
							v-for="(img, index) in news.images.slice(1, 5)"
							:key="index"
							@click="showMultiple(index + 1)">
							<div class="over-flow" v-if="overFlowImage != 0 && index == 3">
								+{{ overFlowImage }}
							</div>
							<img :src="img" alt />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Loader from '@/components/Loader';
import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.es5.esm.min.js';
import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css';
import { moment } from '@/helpers';

export default {
	components: {
		Breadcrumbs,
		Loader,
		VueEasyLightbox,
	},
	data() {
		return {
			visible: false,
			index: 0,

			loading: true,
			news: null,
		};
	},

	methods: {
		showRelated() {
			this.$refs.related.classList.toggle('show');
		},
		show() {
			this.visible = true;
		},
		handleHide() {
			this.visible = false;
		},
		showMultiple(index) {
			this.index = index;
			this.show();
		},
		moment,
	},

	computed: {
		overFlowImage() {
			if (this.news.images.length > 5) return this.news.images.length - 5;
			else return 0;
		},
	},

	mounted() {
		this.$store
			.dispatch('news/fetchById', { id: this.$route.params.id })
			.then((data) => {
				this.news = data;
			})
			.finally(() => {
				this.loading = false;
			});
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
}
.container > .news-content {
	margin: 0 70px;
}
.top {
	padding: 20px;
}
.title {
	color: var(--green-color);
	font-size: 32px;
	font-family: changeBold;
	line-height: 40px;
}
.date {
	font-size: 16px;
	color: grey;
	line-height: 22px;
}
.main {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 50px !important;
}
.imgs {
	flex: 1;
	padding: 7px;
}
.big-img {
	width: 100%;
	padding-bottom: 7px;
}
.big-img img {
	width: 100%;
	box-shadow: 3px 3px 3px #ccc;
	border-radius: 10px;
	cursor: pointer;
}
.related-imgs {
	width: 100%;
	height: 10vw;
	display: flex;
	justify-content: right;
}
.related-imgs > div {
	height: 100%;
	width: 25%;
	margin: 1%;
	position: relative;
}
.related-imgs > div:first-child {
	padding-right: 0;
}
.related-imgs > div:last-child {
	padding-left: 0;
}
.over-flow {
	background: #000a;
	position: absolute !important;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	z-index: 1;
	border-radius: 7px;
	color: white;
	font-size: 28px;
	font-family: changeMedium;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.related-imgs img {
	height: 100%;
	width: 100%;
	object-fit: cover;
	box-shadow: 3px 3px 3px #ccc;
	border-radius: 7px;
	cursor: pointer;
}
.para {
	white-space: pre-line;
	padding: 0 20px;
	flex: 1;
}
.arrow {
	display: none;
}
@media only screen and (max-width: 992px) {
	.container > .news-content {
		margin: 0 10px;
	}
	.main {
		flex-direction: column;
		align-items: center;
	}
	.imgs {
		margin-bottom: 40px;
		width: 90%;
		display: flex;
	}
	.big-img {
		flex: 4;
		padding-bottom: 0;
		padding-left: 7px;
	}
	.related-imgs {
		flex: 1;
		flex-direction: column;
		width: 100%;
		justify-content: space-between;
		height: unset;
	}
	.related-imgs > div {
		height: 23%;
		width: 100%;
	}
}
@media only screen and (max-width: 575px) {
	.arrow {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		width: 20px;
		height: 20px;
		white-space: nowrap;
		background: var(--green-color);
		color: white;
		top: 0;
		right: -20px;
	}
	.big-img {
		padding-left: 0;
		padding-bottom: 7px;
	}
	.imgs {
		flex-direction: column;
	}
	.related-imgs {
		flex-direction: row;
		flex-wrap: wrap;
	}
	.related-imgs > div {
		height: 30vw;
		width: 48%;
	}
	.show {
		max-width: 1000px;
	}
}

/**       lightbox        */
.vel-img-wrapper {
	position: relative !important;
}

.prev {
	border-bottom: 10px solid #0008;
	border-right: 10px solid #0008;
	transform: rotate(-45deg);
	width: 50px;
	height: 50px;
	position: absolute;
	top: 50%;
	left: 94%;
}
.next {
	border-bottom: 10px solid #0008;
	border-right: 10px solid #0008;
	transform: rotate(135deg);
	width: 50px;
	height: 50px;
	position: absolute;
	top: 50%;
	left: 2%;
}
@media only screen and (max-width: 992px) {
	.prev {
		left: 89%;
		width: 30px;
		height: 30px;
		border-bottom: 5px solid #0008;
		border-right: 5px solid #0008;
	}
	.next {
		width: 30px;
		height: 30px;
		border-bottom: 5px solid #0008;
		border-right: 5px solid #0008;
	}
}
/**       lightbox      end  */
</style>
